import React from 'react';

const FeatureCard = ({ title, description, theme }) => (
    <div className={`py-12 border-t group transition-colors duration-500 ${theme === 'dark' ? 'border-zinc-900' : 'border-zinc-200'}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
            <h3 className={`text-3xl font-bold tracking-tight transition-colors ${theme === 'dark' ? 'text-white group-hover:text-zinc-400' : 'text-black group-hover:text-zinc-600'}`}>
                {title}
            </h3>
            <p className={`text-lg leading-relaxed max-w-lg transition-colors ${theme === 'dark' ? 'text-zinc-500' : 'text-zinc-600'}`}>
                {description}
            </p>
        </div>
    </div>
);

const FeatureGrid = ({ theme }) => {
    const features = [
        {
            title: "Data-Driven Precision",
            description: "Kypser operates exclusively on your property's verified operational data. It never guesses. It responds with accuracy and consistency."
        },
        {
            title: "Immediate Resolution",
            description: "Zero wait times for guests. Whether it's 3 PM or 3 AM, information flows instantly without disturbing your sleep or staff."
        },
        {
            title: "Human Escalation",
            description: "Technology that knows its limits. When a human touch is required, Kypser seamlessly alerts your team with full context."
        },
        {
            title: "Global Compatibility",
            description: "Native multilingual support built-in. Your property communicates flawlessly in every guest's preferred language."
        }
    ];

    return (
        <div className="flex flex-col mt-12">
            {features.map((f, i) => (
                <FeatureCard key={i} title={f.title} description={f.description} theme={theme} />
            ))}
            <div className={`border-t transition-colors duration-500 ${theme === 'dark' ? 'border-zinc-900' : 'border-zinc-200'}`}></div>
        </div>
    );
};

export default FeatureGrid;

